// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xe-1";
export var printerIcon = "_xe-0";